/* GuideScreen — the Playground Guide as an APP-LEVEL standalone page (a sibling
 * of the apps list, not inside the per-app shell). The guide is global, so it
 * opens without an app context. Mirrors LearnScreen/AppsList: appstudio theme on
 * <body> + the embedded full-height root so the guide owns its own scroll. */
import React, { useEffect } from 'react';
import GuidePage from './GuidePage';
import { readStoredMode } from '../../ui/themeMode';
import '../../ui/tokens.css';
import '../../ui/shell.css';

export default function GuideScreen() {
  const mode = readStoredMode();

  useEffect(() => {
    document.body.setAttribute('data-theme', 'appstudio');
    document.body.setAttribute('data-aps-mode', mode);
    return () => {
      document.body.removeAttribute('data-theme');
      document.body.removeAttribute('data-aps-mode');
    };
  }, [mode]);

  return (
    <div className="aps-root aps-root-embedded" data-theme="appstudio" data-aps-mode={mode}>
      <GuidePage />
    </div>
  );
}
